import React from 'react';

import {
  BeaconForm,
  BeaconFormHeader,
  useBeaconView,
  BeaconFormHeaderIcon,
} from '@fingermarkglobal/cringer.components';
import BeaconImage from '../../assets/images/beacon.png';

const CustomBeaconView = () => {
  const {
    t,
    inputError,
    beaconValue,
    currentSettings,
    allowSubmit,
    secondaryAction,
    primaryAction,
    showSecondaryAction,
  } = useBeaconView();
  return (
    <div className="beacon-view" data-test="beacon-view">
      <BeaconFormHeader t={t} Icon={BeaconFormHeaderIcon({ Image: BeaconImage })} />
      <BeaconForm
        allowPrimaryAction={allowSubmit}
        beaconValue={beaconValue}
        currentSettings={currentSettings}
        inputError={inputError}
        primaryAction={primaryAction}
        secondaryAction={secondaryAction}
        showSecondaryAction={showSecondaryAction}
        t={t}
      />
    </div>
  );
};

export { CustomBeaconView };
